// Multi-currency formatting. All money in the API is BIGINT minor units (cents)
// stored as USD canonical. We convert on display.

import i18n from '../i18n'

export type Currency = 'USD' | 'CAD' | 'GBP' | 'EUR'

export const FX: Record<Currency, number> = {
  USD: 1,
  CAD: 1.37,
  GBP: 0.79,
  EUR: 0.92,
}

export const SYMBOL: Record<Currency, string> = {
  USD: '$',
  CAD: 'C$',
  GBP: '£',
  EUR: '€',
}

interface FormatOpts {
  compact?: boolean
  decimals?: number
}

function getLocale(): string {
  return i18n.language.startsWith('tr') ? 'tr-TR' : 'en-US'
}

export function fmtMoney(usdMinor: number | bigint, currency: Currency = 'USD', opts: FormatOpts = {}): string {
  const minor = typeof usdMinor === 'bigint' ? Number(usdMinor) : (usdMinor ?? 0)
  const v = minor * FX[currency] / 100
  const sym = SYMBOL[currency]
  if (opts.compact) {
    const abs = Math.abs(v)
    if (abs >= 1_000_000) return sym + (v / 1_000_000).toFixed(2) + 'M'
    if (abs >= 1_000)     return sym + (v / 1_000).toFixed(1) + 'K'
    return sym + v.toFixed(opts.decimals ?? 2)
  }
  return sym + v.toLocaleString(getLocale(), {
    minimumFractionDigits: opts.decimals ?? 2,
    maximumFractionDigits: opts.decimals ?? 2,
  })
}

export const fmtPct = (v: number, d = 1) => (v >= 0 ? '+' : '') + v.toFixed(d) + '%'
export const arrow = (v: number) => (v >= 0 ? '▲' : '▼')
export const tone = (v: number) => (v >= 0 ? 'text-mint-600' : 'text-flame-600')

export function getFMT_INT(): Intl.NumberFormat {
  return new Intl.NumberFormat(getLocale(), { maximumFractionDigits: 0 })
}

export const FMT_INT = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })

export function relativeTime(minutes: number): string {
  if (minutes < 60) return minutes + 'm ago'
  const h = Math.floor(minutes / 60)
  if (h < 24) return h + 'h ago'
  return Math.floor(h / 24) + 'd ago'
}
